enum NotificationDispatchStatus {
  PENDING = 'PENDING',
  DISPATCHED = 'DISPATCHED',
  FAILED = 'FAILED'
}

export default NotificationDispatchStatus